import i18n from "i18next";
import { initReactI18next } from 'react-i18next';
import LanguageDetector from "i18next-browser-languagedetector";
import usFlag from "../assets/images/us.svg";
import mxFlag from "../assets/images/mx.svg";
import defaultConfig from '../configs';

export const getI18nTranslationOrDefaultValue = (namespace = '', key, defaultValue = key) => {
  if(i18n.exists(`${namespace}.${key}`)){
    return i18n.t(`${namespace}.${key}`);
  }
  else {
    return defaultValue;
  }
};
// i18n
//   .use(LanguageDetector)
//   .use(initReactI18next)
//   .init({
//     fallbackLng: 'en',
//     debug: true,
//     detection: {
//       // order: ['navigator']
//       // cache: []
//     },
//     useLocalStorage: false,
//   })
//   .then(() => {
//     console.log(i18n.languages);
//   })

export const languageOptions = [
  {
    value: 'en-US',
    label: 'English (US)',
    icon: usFlag,
  },
  {
    value: 'es-MX',
    label: 'Español (MX)',
    icon: mxFlag,
  },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: defaultConfig.i18n.resources,
    ns: ["translations"],
    defaultNS: "translations",
    fallbackLng: 'en-US',
    debug: true,
    detection: {
      order: ['localStorage', 'querystring'],
    },
    react: {
      useSuspense: false,
    }
  });

export default i18n;
